import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, Heart } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#920216] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Sobre */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#CDAD1E]">Harmonia Nupcial</h3>
            <p className="text-sm text-white/90 leading-relaxed">
              A trilha sonora perfeita para o seu "sim". Especializados em cerimônias católicas em Brasília e Entorno.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#CDAD1E]">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-white/90 hover:text-[#CDAD1E] transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/musicas" className="text-sm text-white/90 hover:text-[#CDAD1E] transition-colors">
                  Sugestões de Músicas
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-sm text-white/90 hover:text-[#CDAD1E] transition-colors">
                  Portfólio
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm text-white/90 hover:text-[#CDAD1E] transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#CDAD1E]">Contato</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`https://wa.me/${companyInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-white/90 hover:text-[#CDAD1E] transition-colors"
                >
                  <Phone size={16} />
                  (61) 99587-8906
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-2 text-sm text-white/90 hover:text-[#CDAD1E] transition-colors"
                >
                  <Mail size={16} />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/harmonianupcialbsb/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-white/90 hover:text-[#CDAD1E] transition-colors"
                >
                  <Instagram size={16} />
                  @harmonianupcialbsb
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-col items-center justify-center gap-3 text-center">
            <p className="text-xs sm:text-sm text-white/80 flex flex-wrap items-center justify-center gap-1">
              <span>© 2025 Harmonia Nupcial.</span>
              <span className="flex items-center gap-1">
                Criando momentos com <Heart size={14} className="text-[#CDAD1E]" fill="currentColor" /> e música.
              </span>
            </p>
            <p className="text-xs sm:text-sm text-white/80">
              {companyInfo.location}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;